import Vue from 'vue'

// Simplest implementation of loading executor
class NetworkCommand {
  constructor (commit, loadingAction, execute, errorAction, transformError) {
    this._updateLoading = typeof loadingAction === 'string'
      ? (b) => commit(loadingAction, b)
      : loadingAction

    this._execute = execute

    this._processError = typeof errorAction === 'string'
      ? (e) => {
          const err = transformError ? transformError(e) : e
          commit(errorAction, err)
        }
      : errorAction
  }

  _getExecuteParams ({ rootGetters }) {
    let accountId
    if (rootGetters) {
      accountId = rootGetters.accountId()
    }
    return { accountId }
  }

  async executeAsync (params) {
    let executeResult
    this._updateLoading(true)
    try {
      const ep = params ? this._getExecuteParams(params) : {}
      executeResult = await this._execute(ep)
    } catch (e) {
      Vue.logger.error(e)
      if (this._processError) {
        this._processError(e)
      }
    } finally {
      this._updateLoading(false)
    }
    return executeResult
  }
}

export default NetworkCommand
